import strFunc from '@/lib/lyg/string';
import Style from './css/style.module.css';

function SelectPointArea(props: any) {
  let myProps = {
    Style: {},
    charge_data: {},
    set_charge_data: (inData: any) => { },
    ...props
  };
  let charge_data = myProps.charge_data;

  let select_charge_point_arr = [
    // { value: 1000, popular: false },
    { value: 10000, popular: false },
    { value: 30000, popular: false },
    { value: 50000, popular: false },
    { value: 100000, popular: false },
    { value: 200000, popular: false },
    { value: 300000, popular: false },
    { value: 500000, popular: false },
    { value: 1000000, popular: false }
  ];

  const get_select_charge_point_tags = () => {
    let return_tags: any = select_charge_point_arr.map((point_item: any, idx: number) => {
      const isSelected = charge_data.point === point_item.value;
      return (
        <div
          key={idx}
          className={`${Style.point_option} ${isSelected ? Style.selected : ''}`}
          onClick={() => {
            let change_charge_data = { ...charge_data };
            change_charge_data["point"] = point_item.value;
            myProps.set_charge_data(change_charge_data);
          }}
        >
          {point_item.popular && <div className={Style.popular_badge}>인기</div>}
          <span className={Style.point_value}>{strFunc.comma(point_item.value)}</span>
          <span className={Style.point_label}>포인트</span>
        </div>
      );
    });
    return return_tags;
  };

  return (
    <div className={Style.select_point_container}>
      {get_select_charge_point_tags()}
    </div>
  );
};
export default SelectPointArea;